<script>
    export let helperText;
    export let label;
    export let placeholder;
    export let name;
    export let type;
    export let required = false;
    export let value = "";
    export let disabled = false;

    export let onKeyup;
    export let onChange;

    function typeAction(node) {
        node.type = type;
    }
</script>

<style lang="scss">
    @import "../../styles/_mixins.scss";

    .disabled {
        background-color: #e1e1e1;
        cursor: not-allowed;

        label,
        input {
            cursor: not-allowed;
        }
    }

    .input-container {
        @include input-container;
    }

    label {
        @include input-label;
    }

    input {
        font-size: var(--font-regular);
        opacity: 0.8;
        border: none;

        &:invalid {
            border: none;
            box-shadow: none;
        }
    }

    p {
        margin-top: -12px;
        margin-bottom: var(--spacer-medium);
        font-size: var(--font-small);
        opacity: 0.3;
    }

    ::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        opacity: 0.3;
    }
    ::-moz-placeholder {
        /* Firefox 19+ */
        opacity: 0.3;
    }
    :-ms-input-placeholder {
        /* IE 10+ */
        opacity: 0.3;
    }
    :-moz-placeholder {
        /* Firefox 18- */
        opacity: 0.3;
    }
</style>

<div class="input-container" class:disabled>
    {#if label}<label for={name}>{label}</label>{/if}
    <input
        {placeholder}
        {name}
        {required}
        bind:value
        use:typeAction
        on:keyup={onKeyup}
        on:change={onChange}
        {disabled} />
</div>

{#if helperText}
    <p>{helperText}</p>
{/if}
